'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import Video from 'react-youtube';
import { YoutubeVideoProps } from './types';
const YoutubeVideo = t0 => {
  const $ = _c(6);
  let props;
  let videoId;
  if ($[0] !== t0) {
    ({
      videoId,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = videoId;
  } else {
    props = $[1];
    videoId = $[2];
  }
  let t1;
  if ($[3] !== props || $[4] !== videoId) {
    t1 = <Video videoId={videoId} {...props} data-sentry-element="Video" data-sentry-component="YoutubeVideo" data-sentry-source-file="index.tsx" />;
    $[3] = props;
    $[4] = videoId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default YoutubeVideo;